import React, { useEffect } from 'react';

export type PageWithTheme = { darkTheme?: boolean };

type Props = {
  Component: PageWithTheme;
  children: React.ReactNode;
};

export function createAppTheme(themes: { light: string; dark: string }) {
  return function AppTheme({ Component: { darkTheme }, children }: Props) {
    useEffect(() => {
      const html = document.documentElement;
      const themeClasses = (darkTheme ? themes.dark : themes.light).split(' ');
      const otherClasses = (darkTheme ? themes.light : themes.dark).split(' ');

      html.classList.remove(...otherClasses);
      html.classList.add(...themeClasses);
    }, [darkTheme, themes.dark, themes.light]);

    return <>{children}</>;
  };
}
